import React from 'react';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';
import { BlockNames } from './block.types';

export function addBlocks(piral: PiletApi) {
	const LazyTaskMgtProviderBlock = React.lazy(() => import('./TaskMgtProviderBlock'));
	piral.registerExtension(BlockNames.Provider, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyTaskMgtProviderBlock {...props} />
		</React.Suspense>
	));

	const LazyTodosListBlock = React.lazy(() => import('./TodosBlock'));
	piral.registerExtension(BlockNames.List, ({ piral: piletApi, params }) => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyTodosListBlock app={piletApi} {...params} />
		</React.Suspense>
	));
}
